module.exports = __webpack_public_path__ + "static/img/wm.8f987ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spec/wm.jpg
// module id = oMJW
// module chunks = 73